<lib-modal
    [title]="'common.info'"
    [bgColorClass]="ColorClass.Success"
    [componentID]="'calculated-price-info-modal'"
>
    <div class="text-center">
        <p>
            {{ 'my-tasks.calculated-price-info' | translate }}
        </p>
    </div>
</lib-modal>
